import { TRAINING_URL, WMT_KIDS_URL } from "@/config/site";

export interface NavigationItem {
  label: string;
  href: string;
  items?: NavigationItem[];
}

export interface NavigationSection extends NavigationItem {
  items?: NavigationItem[];
}

export const serviceNavigationItems: NavigationItem[] = [
  { label: "Обучение", href: TRAINING_URL },
  { label: "Личный ИИ", href: "/education/personal-ai" },
  { label: "Курсы по ИИ", href: "/education/courses" },
  {
    label: "Нейроключ",
    href: "https://wmt-ai.ru/neiroklyuch/",
  },
  {
    label: "Нейромаск",
    href: "https://neiromask.vercel.app/",
  },
  {
    label: "Релевантер",
    href: "https://wmt-ai.ru/relevanter/",
  },
  { label: "Аутстаффинг", href: "https://wmtgroup.ru/" },
  { label: "Детское обучение", href: WMT_KIDS_URL },
];

const headerServiceNavigationItems: NavigationItem[] = [
  {
    label: "Обучение",
    href: TRAINING_URL,
    items: [
      { label: "Личный ИИ", href: "/education/personal-ai" },
      { label: "Курсы по ИИ", href: "/education/courses" },
    ],
  },
  ...serviceNavigationItems.filter(
    item => !["Аутстаффинг", "Обучение", "Личный ИИ", "Курсы по ИИ"].includes(item.label),
  ),
];

export const primaryNavigationItems: NavigationSection[] = [
  { label: "О компании", href: "/" },
  {
    label: "Услуги",
    href: "#directions",
    items: headerServiceNavigationItems,
  },
  { label: "Кейсы", href: "/cases" },
  {
    label: "Блог",
    href: "/blog",
    items: [
      { label: "Публикации в СМИ", href: "/blog#media" },
      { label: "Статьи для бизнеса", href: "/blog#business" },
      { label: "Исследования рынка", href: "/blog#research" },
    ],
  },
  { label: "Команда", href: "/team" },
];

export const footerNavigationItems: NavigationItem[] = [
  { label: "Услуги", href: "/#directions" },
  { label: "Кейсы", href: "/cases" },
  { label: "Блог", href: "/blog" },
  { label: "Команда", href: "/team" },
  ...serviceNavigationItems,
  { label: "О компании", href: "/" },
  { label: "Игорь Никитин", href: "/team/igor_nikitin" },
  { label: "Андрей Майнгардт", href: "/andrey_meinhardt" },
  { label: "Юлия Болтуцкая", href: "/team/yulia_boltutskaya" },
];

export const educationNavigationItems: NavigationSection[] = [
  ...primaryNavigationItems.slice(0, 2),
  { label: "Программы обучения", href: "#programs" },
  ...primaryNavigationItems.slice(2).filter(item => item.href !== "#research"),
];
